/** @jsx jsx */
import { jsx, Heading, Container, Flex, Box, Divider } from "theme-ui"
import { MDXRenderer } from "gatsby-plugin-mdx"
import React from "react"
import Layout from "./layout"
import SEO from "./seo"
import ShareButtons from "./social-share-buttons"
import replaceSlashes from "../utils/replaceSlashes"
import useMinimalBlogConfig from "../hooks/use-minimal-blog-config"

type PostProps = {
  data: {
    project: {
      slug: string
      title: string
      date: string
      tags?: {
        name: string
        slug: string
      }[]
      description?: string
      body: string
      excerpt: string
      banner?: {
        childImageSharp: {
          resize: {
            src: string
          }
        }
      }
    }
  }
}

const px = [`32px`, `16px`, `8px`, `4px`]
const shadow = px.map((v) => `rgba(0, 0, 0, 0.10) 0px ${v} ${v} 0px`)

const Post = ({ data: { project } }: PostProps) => {
  const { basePath } = useMinimalBlogConfig()

  return (
    <Layout>
      <SEO
        title={project.title}
        description={project.description ? project.description : project.excerpt}
        image={project.banner ? project.banner.childImageSharp.resize.src : undefined}
        pathname={replaceSlashes(`/project/${project.slug}`)}
      />
        <Box
          sx={{
            textAlign: `center`
          }}
        >
          <div sx={{ px: [3, 4], pt: [4, 5] }}>
            <Container sx={{ p: 0 }}>
              <span>PROJECT</span>
              <Heading
                as="h1"
                sx={{
                  lineHeight: 1.5,
                  fontFamily: `monospace`,
                  color: `primary`,
                  fontSize: [3, 4, 5],
                }}
              >
                {project.title}
              </Heading>
              <p
                sx={{
                  mt: 3,
                  fontSize: [1, 1, 2],
                  color: `secondary`,
                  // color: theme => `${theme.colors.steelBlue}`,
                  width: [`90%`, `70%`],
                  mx: `auto`,
                }}>
                {project.description}
              </p>
              <Divider sx={{ borderColor: theme => `${theme.colors.divide}` }} />
            </Container>
          </div>
        </Box>

        <div sx={{ px: [3, 4], pt: [3, 0, 0],  pb: [3, 4] }}>
          <Container sx={{ p: 0 }}>
            <section
              sx={{
                mt: [2, 3, 4],
                mb: [3, 4, 5],
                ".gatsby-resp-image-wrapper": { my: [4, 4, 5], boxShadow: shadow.join(`, `) },
                a: {
                  borderBottom: theme => `3px solid ${theme.colors.secondary}`,
                  pb: `3px`,
                  ':hover': {
                    pb: `1px`,
                  }
                }
              }}>
              <MDXRenderer>
                {project.body}
              </MDXRenderer>
            </section>
          {/*
            <section sx={{ my: [2, 3] }}>
              <Flex sx={{ alignItems: `center` }}>
                {project.tags && (
                  <>
                    <span sx={{ mr: [2] }}>Tags:</span>
                    {
                      project.tags.map((tag) => (
                        <TagButton key={tag.name} value={tag.name} toUrl={replaceSlashes(`/${basePath}/${tagsPath}/${kebabCase(tag.name)}`)} />
                      ))
                    }
                  </>
                )}
              </Flex>
            </section> */}

            <section sx={{ my: [2, 3] }}>
              <ShareButtons path={replaceSlashes(`/${basePath}/project/${project.slug}`)} />
            </section>

          </Container>
        </div>
    </Layout>
  )
}

export default Post
